import { Commet, OrbitProgress } from "react-loading-indicators"

function LoadingComponent() {
    return (<div className="w-full h-fit flex items-center justify-center pt-8">
        <OrbitProgress color="#132A30" size="medium" text="" textColor="" />
    </div>)
}

export default LoadingComponent